const es = {
  task: {
    center: "Centro de tareas",
    callTask: "Tarea de llamada",
    giftTask: "Tarea de regalo",
    liveTask: "Tarea para recién llegados",
    sevenTask: "Tarea de 7 días",
    callMessage: "Llame más para obtener recompensas",
    giftMessage: "Reciba regalos para obtener recompensas",
    liveMessage: "Aumente la duración de Live para obtener una recompensa de {d}",
    sevenMessage: "Complete las tareas diarias para obtener una recompensa de {d}",
    cellTitle: "Llame ≥{d} minutos (veces):",
    reward: "Recompensa",
    lastWeek: "Recompensa de la semana pasada::",
    weekGift: "Ingresos semanales por obsequios:",
    RewardDescription: "Recompensa instrucciones",
    everyWeekGift: "Ingresos semanales por obsequios <span class='web'>(Bonus)</span>",
    endTask: 'La tarea ha terminado',
    query: 'Okay'
  },
  message: {
    taxt1: "1. Cada ciclo de liquidación es de lunes a domingo. Cuanto mayor sea la duración de la videollamada ≥{d} minutos, más generosas serán las recompensas.",
    taxt2: "2. Solo puede obtener recompensas de un nivel por semana, según la evaluación de los tiempos de duración de su llamada única esa semana ≥{d} minutos",
    taxt3: "3. Después de la verificación oficial, las recompensas se emitirán a su cuenta antes el próximo jueves después de la liquidación",
    taxt4: "4. Si se encuentra haciendo trampa, será descalificado para cualquier recompensa",
    taxt5: "5. Si tiene alguna pregunta, consulte：<span class='web'>support@honeycamweb.com</span>",
    hint: "Notas: Sujeto a hora internacional.",
    rewardOne1: "1.Dentro de los 7 días posteriores al inicio de la tarea",
    rewardOne2: "1) Live≥2 horas y la tasa de finalización de llamadas ≥{d} al día durante al menos 6 días;",
    rewardOne3: "2) Dentro de los 7 días posteriores al inicio de la tarea, el ingreso total alcanza ≥{d}Bonus;",
    rewardOne4: "3) Si las condiciones anteriores se cumplen al mismo tiempo, puede obtener una recompensa de <span style='color: #ff2794'>{d}</span> de la plataforma después de que finalice la tarea;",
    rewardOne5: "2.Un ancla puede recompensar a una cuenta como máximo y varias cuentas no son válidas;",
    rewardOne6: "3.Si se encuentra una trampa, se cancelará la calificación para las recompensas;",
    rewardOne7: "El usuario que completó la tarea, una vez finalizada la tarea. Siga la página de inicio oficial de <span class='web' style='color: #f99634'>Facebook \"Honeycam\"</span> y agregue un grupo para obtener una recompensa de <span style='color: #ff2794'>$10</span>;",
    rewardOne8: "5.Si tiene alguna pregunta, consulte：<span class='web'>support@honeycamweb.com;</span>",
    rewardTwo1: "Los usuarios que ganen más de $10 en el día durante la misión tendrán la oportunidad de ingresar a la primera posición de las páginas recomendadas o populares al día siguiente para ganar más exposición;"
  },
  gift: {
    test1: "1. El ciclo de liquidación es de lunes a domingo. Cuantos más regalos reciba, más generosas serán las recompensas.",
    test2: "2. Solo puede obtener recompensas por un nivel cada semana, y el nivel se evalúa en función de los ingresos totales de esa semana.",
    test3: "3. Después de la verificación oficial, la recompensa se enviará a su cuenta de ingresos antes del próximo jueves.",
    test4: "4. Si se encuentra una trampa, será descalificado para cualquier recompensa",
    test5: "5. Si tiene alguna pregunta, consulte：<span class='web'>support@honeycamweb.com</span>",
    giftNum: "Regalos recibidos ≥{d}",
    totalBonus: "Ingresos ≥{d}Bonus",
    liveCallTime: "<span class='web'>live</span>≥{d}(m)",
    callTime: "Llamar ≥{d}(m)",
    callRate: "接通率≥{d}%"
  },
  new: {
    rewardOne: "Recompensa uno",
    rewardTwo: "Recompensa dos",
    start: "La tarea se inauguró oficialmente a las 0:00 de hoy",
    hint: "Mantenga Live≥{d} horas y la tasa de finalización de llamadas ≥{d} por día.Puede obtener una recompensa de {d}.",
    tastReward: "Ingresos totales <span class='web'>Bonus</span> durante la misión",
    liveTime: "Duración de Live de hoy",
    callRate: "Tasa de finalización de llamadas para hoy",
    progress: "Progreso de la tarea",
    endRate: "(objetivo ≥",
    overText1: "Felicitaciones por la finalización de la tarea",
    overText2: "Siga la <span class='web'>Facebook \"Honeycam\"</span> y agregue un grupo para obtener una recompensa de {d}.",
    overText3: "Es una pena que la tarea no se haya completado y no pueda obtener la recompensa de {d}",
    overText4: "Siga la <span class='web'>Facebook \"Honeycam\"</span> para obtener más información sobre la tarea.",
    openfb: "Abre el <span class='web'>Facebook</span>",
  },
  week: {
    live30: "Mañana Live≥{d} minutos",
    call5: "Mañana llamar ≥5 minutos",
    rewardHint: "(Si se completan todas las siguientes tareas, <span style='color: #ff2794'>obtendrá una recompensa adicional de<span class='web'>$20</span></span>)",
    newLive: "Hoy Live>",
    newLiveSec: "(objetivo ≥{d})",
    newCall: "Llamada de hoy",
    newCallRate: "Tasa de finalización de llamadas para hoy",
    newBonus: "Ingreso de hoy Bonsu",
    newGift: "Número de obsequios de hoy",
    newReward: "Recompensas de hoy",
    days: "Dias",
    taskReq: "Requisitos de la tarea",
    task1: "Las tareas de cada día se liquidan a las 0:00 y se envían a su cuenta de Bonus a las 0:00;",
    task2: "2.Si la tarea no se completa ese día, fallará. La tarea fallida no se puede reanudar;",
    task3: "3.Solo se completan todas las tareas de 7 días, se puede obtener un paquete de recompensa de {d};",
    task4: "4.Un ancla puede recompensar a una cuenta como máximo y varias cuentas no son válidas;",
    task5: "5.Si se encuentra una trampa, se cancelará la calificación para las recompensas;",
    task6: "El usuario que completó la tarea, una vez finalizada la tarea. Siga la página de inicio oficial de <span class='web' style='color: #f99634'>Facebook \"Honeycam\"</span> y agregue un grupo para obtener una recompensa de <span style='color: #ff2794' class='web'>$20</span>;",
    task7: "7.Si tiene alguna pregunta, consulte al funcionario：<span class='web'>support@honeycamweb.com;</span>",
  }
};

export default es;
